var angular = require("angular")
var UserAPI = require("../../api").User;


angular
 .module("app.directives")
 .directive('notificationsettings', function(){
   return {
     restrict: 'E',
     scope: {
       answers: "="
     },
     replace:true,
     template: require('./form.pug'),
     link: function(scope, element, attrs){

       scope.initialLoad = true;
       scope.loading = false;
       scope.questions = [];

       scope.init = function() {
         scope.loading = true;
         UserAPI.GetQuestions()
           .then(function(questions) {
             scope.loading = scope.initialLoad = false;
             scope.questions = questions;
           })
           .catch(function() {
             scope.loading = scope.initialLoad = false;
           });
       };

       scope.init();

     }
   }
 })
